import { object, ref, string } from "yup";

export const activateUserValidation = object({
  password: string()
    .min(6, "passwordMinRule")
    .max(64, "passwordMaxRule")
    .required(),
  confirmPassword: string()
    .required()
    .oneOf([ref("password")], "passwordsMustMatch"),
});
